export default {
  title: "Support",
  rules: {
    note: "Avant d’envoyer une demande, veuillez prendre connaissance des règles :",
    rule_1: "1. Consultez d’abord la section {faq} (FAQ) — la réponse s’y trouve peut-être déjà.",
    rule_2: "2. En cas de problème de paiement, veuillez joindre les détails de la transaction (date, montant, moyen de paiement, captures d’écran).",
    rule_3: "3. En cas de problème de téléchargement de fichiers, veuillez indiquer les liens vers ces fichiers.",
    rule_4: "4. Pour les questions de droits d’auteur ou tout autre fichier enfreignant les règles, contactez : {email}",
    rule_5: "5. Pour la coopération, les programmes d’affiliation, la publicité et toute autre proposition commerciale, écrivez à : {email}",
    rule_6: "6. La réponse peut prendre de 12 heures à 2 jours ouvrés, selon la complexité de la demande et la charge du support.",
    rules: "règles",
    faq: "foire aux questions"
  },
  messages: {
    note: "*Affichage des {count} derniers messages",
    you: "Vous",
    support: "Support",
    autoanswer_subject_is_over: "La conversation est fermée car votre problème a été résolu.\nMerci d’avoir contacté le support technique."
  },
  inputs: {
    message: {
      placeholder: "Écrivez votre question"
    },
    attachments: {
      btn: "{text} {formats}",
      attach_file: "Joindre un fichier",
      attached_files: "Fichiers joints :"
    }
  },
  errors: {
    generic: "Erreur",
    invalid_file_type: "Format de fichier non pris en charge.",
    max_file_size_limit: "Le fichier est trop volumineux. Choisissez un fichier plus petit.",
    filename_too_long: "Le nom du fichier est trop long",
    filename_invalid_chars: "Le nom du fichier contient des caractères invalides"
  },
  btn: {
    send: "Envoyer"
  }
};
